import { makeStateKey } from "@angular/core";

export const REQUEST_MARK_KEY = makeStateKey<string>('REQUEST_MARK_KEY');